import React from 'react';
import { motion } from 'framer-motion';
import { worksAnimations, childern } from '../helpers/animation';
import { useScroll } from '../helpers/scrollAnimations';
import { Link } from 'react-router-dom';

const Works = () => {
	const [element, controls] = useScroll();
	return (
		<motion.div
			animate={controls}
			ref={element}
			initial="hidden"
			variants={worksAnimations}
			id="works"
			className="section works"
		>
			<h2>Works</h2>
			<div className="group">
				<Link to={{ pathname: 'https://imgur.com/XdQ5ATA' }} target="_blank">
					<motion.div variants={childern} className="work c">
						<h1>Food app</h1>
						<p>Ionic React + Node js</p>
					</motion.div>
				</Link>
				<Link
					to={{ pathname: 'https://admiring-austin-e1acbe.netlify.app/' }}
					target="_blank"
				>
					<motion.div variants={childern} className="work a">
						<h1>Weather</h1>
					</motion.div>
				</Link>
				<Link
					to={{ pathname: 'https://pensive-perlman-d93593.netlify.app/' }}
					target="_blank"
				>
					<motion.div variants={childern} className="work b">
						<h1>Ecommerce site</h1>
					</motion.div>
				</Link>
				<Link
					to={{ pathname: 'https://optimistic-nobel-e5e2ad.netlify.app/' }}
					target="_blank"
				>
					<motion.div variants={childern} className="work d">
						<h1>Music Player</h1>
						<p>(followed tutorial)</p>
					</motion.div>
				</Link>
				<Link
					to={{ pathname: 'https://musing-kalam-506ca9.netlify.app/' }}
					target="_blank"
				>
					<motion.div variants={childern} className="work e">
						<h1>Game store</h1>
						<p>(followed tutorial)</p>
					</motion.div>
				</Link>
			</div>
		</motion.div>
	);
};

export default Works;
